'use client';
import React from 'react';

export default function HelloSection() {
  return (
    <section
      className="w-full"
      style={{ backgroundColor: '#EFE3E1', paddingTop: 'clamp(64px, 8vw, 120px)', paddingBottom: 'clamp(64px, 8vw, 120px)' }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 clamp(24px, 4vw, 64px)' }}>
        {/* Asymmetric grid: 45/55 */}
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">

          {/* Image column */}
          <div className="w-full lg:w-5/12 flex-shrink-0">
            <div style={{ position: 'relative' }}>
              {/* Reserved aspect-ratio box prevents layout shift */}
              <div style={{ position: 'relative', width: '100%', aspectRatio: '3 / 4', overflow: 'hidden' }}>
                <img
                  src="/assets/images/image_2026-06-18_111913028-1781777899598.png"
                  alt="Dr Jennifer Morgan — Chartered Clinical Psychologist"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center top',
                    display: 'block',
                  }}
                />
              </div>
              {/* Floating credential badge */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '24px',
                  right: '-16px',
                  backgroundColor: '#1A2332',
                  padding: '16px 20px',
                  maxWidth: '200px',
                }}
                className="hidden lg:block"
              >
                <p
                  style={{
                    fontFamily: 'adobe-garamond-pro, Georgia, serif',
                    fontSize: '11px',
                    letterSpacing: '0.1em',
                    textTransform: 'uppercase',
                    color: 'rgba(245,240,234,0.5)',
                    marginBottom: '4px',
                  }}
                >
                  Qualifications
                </p>
                <p
                  style={{
                    fontFamily: 'adobe-garamond-pro, Georgia, serif',
                    fontSize: '13px',
                    color: '#E8D8D5',
                    lineHeight: '1.6',
                  }}
                >
                  BA Hons · MSc · DClinPsych(Oxon) · DipCAT · CPsychol
                </p>
              </div>
            </div>
          </div>

          {/* Text column */}
          <div className="w-full lg:w-7/12">
            {/* Eyebrow */}
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: '11px',
                letterSpacing: '0.16em',
                textTransform: 'uppercase',
                color: '#8A9E8C',
                marginBottom: '20px',
              }}
            >
              About Dr Morgan
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginBottom: '36px' }}>
              <p
                style={{
                  fontFamily: 'adobe-garamond-pro, Georgia, serif',
                  fontSize: 'clamp(16px, 1.3vw, 19px)',
                  color: '#4A4A4A',
                  lineHeight: '1.75',
                }}
              >
                I work as a Consultant Clinical Psychologist with over 20 years of clinical experience across NHS, independent and private practice settings. I completed my clinical training at the University of Oxford and have since developed a private practice focused on providing highly individualised, formulation-led psychological care.
              </p>
              <p
                style={{
                  fontFamily: 'adobe-garamond-pro, Georgia, serif',
                  fontSize: 'clamp(16px, 1.3vw, 19px)',
                  color: '#4A4A4A',
                  lineHeight: '1.75',
                }}
              >
                I work with a limited number of clients in order to maintain depth, continuity and quality of care.
              </p>
              <p
                style={{
                  fontFamily: 'adobe-garamond-pro, Georgia, serif',
                  fontSize: 'clamp(16px, 1.3vw, 19px)',
                  color: '#4A4A4A',
                  lineHeight: '1.75',
                }}
              >
                My approach is grounded in the belief that psychological difficulties are best understood within the context of a person&apos;s life, relationships, history and current circumstances. Rather than applying a fixed model of therapy, I take an integrative and reflective approach, drawing on a range of evidence-based psychological frameworks to develop a clear and meaningful understanding of each individual.
              </p>
              <p
                style={{
                  fontFamily: 'adobe-garamond-pro, Georgia, serif',
                  fontSize: 'clamp(16px, 1.3vw, 19px)',
                  color: '#4A4A4A',
                  lineHeight: '1.75',
                }}
              >
                At the heart of my practice is a simple principle: meaningful psychological change arises from understanding, not just intervention.
              </p>
            </div>

            <a
              href="/about"
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: '13px',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: '#EFE3E1',
                backgroundColor: '#1A2332',
                padding: '14px 32px',
                textDecoration: 'none',
                display: 'inline-block',
                transition: 'background-color 0.25s ease',
              }}
              onMouseEnter={e => ((e.currentTarget as HTMLElement).style.backgroundColor = '#2C2C2C')}
              onMouseLeave={e => ((e.currentTarget as HTMLElement).style.backgroundColor = '#1A2332')}
            >
              Read Dr Morgan&apos;s Full Profile
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}